export const minutesToMilliseconds = (minutes: number): number => {
	return minutes * 60 * 1000;
};
